/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, May 3, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

import par from "par";

import defineUI from "../shared/define";
import render from "./render.jsx";
import PersonStore from "../stores/person_store";
import OrgStore from "../stores/org_store";
import ResourceStore from "../stores/admin_resources_store";
import LocalizationStore from "../stores/localization_store";
import CurrentPersonInfoStore from "../stores/current_person_info_store";
import CareplanNotificationStore from "../stores/careplan_notice_store";
import ConnectionStore from "../stores/connection_store";
import AdminOrgStore from "../stores/admin_org_store";
import makeStoreFactory from "../shared/stores";

const makeStores = makeStoreFactory({
	orgs: OrgStore,
	allOrgs: AdminOrgStore,
	people: PersonStore,
	resources: ResourceStore,
	currentPerson: CurrentPersonInfoStore,
	localization: LocalizationStore,
	careplanChangeList: CareplanNotificationStore,
	connection: ConnectionStore,
});

export default make_ui;

function make_ui(api, events, config, userMetrics) {
	var storeStore = makeStores(api, events, config);

	window.stores = storeStore.store;

	userMetrics.trackEvent("page view", {
		"page": "admin-resources",
		"category": "admin",
		"permission level": "admin",
	});

	return defineUI({
		getInitialState: getInitialState,
		componentDidMount: listen_for_changes,
		render: render,
		componentWillUnmount: removeListeners
	});

	function removeListeners() {
		events.off();
	}

	function listen_for_changes() {
		storeStore.listen(par(handle_change, this));
	}

	function getInitialState() {
		return {
			orgs: [],
			allOrgs: [],
			loadMore: par(loadMore, storeStore.stores.orgs),
			people: storeStore.stores.people,
			resources: storeStore.stores.resources,
			currentPerson: storeStore.stores.currentPerson,
			localization: storeStore.stores.localization,
			searchOrg: par(searchOrg, storeStore.stores.orgs),
			careplanChangeList: storeStore.stores.careplanChangeList,
			connection: storeStore.stores.connection,
			updating: false,
			creating: false,
			createResource: createResource,
			updateResource: updateResource,
			removeResource: removeResource,
			duplicateResource: duplicateResource,
			language: "en",
			isDuplicating: false,
			duplicateOrg: "",
			errorToast: false,
			openToast: false,
			inProgressToast: false,
			toastMessage: "",
			isMissingDestination: false,
			dialogErrors: null,
			userMetrics: userMetrics,
		};
	}

	function duplicateResource(resource, org, destination) {
		return api.admin.resources.duplicate(resource, org, destination);
	}

	function searchOrg(orgs, event) {
		event.persist();
		var query = event.target.value;
		return orgs.search(query);
	}

	function loadMore(orgs) {
		return orgs.more();
	}

	function handle_change(component, stores) {
		component.setState({
			orgs: stores.orgs.all(),
			allOrgs: stores.allOrgs.all(),
			people: stores.people,
			resources: stores.resources,
			currentPerson: stores.currentPerson,
			localization: stores.localization,
			careplanChangeList: stores.careplanChangeList,
			connection: stores.connection
		});
	}

	function createResource(name, data, org){
		if(!name || !data || !org) return;
		return api.admin.resources.create(name, data, org);
	}

	function updateResource(name, data, org, resource){
		if(!name || !data || !resource) return;
		return api.admin.resources.update(name, data, resource, org);
	}

	function removeResource(resource, org){
		if(!resource || !org) return;
		return api.admin.resources.remove(resource, org);
	}
}
